var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-\\uD83D\\uDD0E-Search-Dropdown-Style-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-Style-Guide",
    transform: "translate(-58.000000, -758.000000)",
    fill: "#858199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico/iconSearch",
    transform: "translate(58.000000, 758.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.2712187,8.02460148 C1.69274641,6.09316732 1.80424096,3.24169517 3.60570234,1.44023379 C5.52601405,-0.480077928 8.6394545,-0.480077928 10.5597662,1.44023379 C12.4800779,3.3605455 12.4800779,6.47398595 10.5597662,8.39429766 C8.75830483,10.195759 5.90683268,10.3072536 3.97539852,8.7287813 L1.05626972,11.6479101 C0.861815838,11.842364 0.546543795,11.842364 0.352089908,11.6479101 C0.157636021,11.4534562 0.157636021,11.1381842 0.352089908,10.9437303 L3.2712187,8.02460148 Z M4.30988216,7.69011784 C5.8412861,9.22152178 8.32418246,9.22152178 9.8555864,7.69011784 C11.3869903,6.1587139 11.3869903,3.67581754 9.8555864,2.1444136 C8.32418246,0.613009662 5.8412861,0.613009662 4.30988216,2.1444136 C2.77847822,3.67581754 2.77847822,6.1587139 4.30988216,7.69011784 Z",
    id: "iconSearch"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/iconSearch.7d643559.svg";
export { ForwardRef as ReactComponent };